import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  uploadSuccess: false,
};

const bulkOrderSlice = createSlice({
  name: "bulkOrder",
  initialState,
  reducers: {
    uploadBulkOrder: (state) => {
      state.loading = true;
      state.error = null;
      state.uploadSuccess = false;
    },
    uploadBulkOrderSuccess: (state, action) => {
      state.loading = false;
      state.uploadSuccess = true;
      state.error = null;
    },
    uploadBulkOrderFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.uploadSuccess = false;
    },
    resetUploadState: (state) => {
      state.loading = false;
      state.error = null;
      state.uploadSuccess = false;
    },
  },
});

export const { actions, reducer } = bulkOrderSlice;
export const sliceKey = bulkOrderSlice.name;